<template>
  <div class="app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-row>
        <v-col v-for="item in 2" :key="item">
          <v-skeleton-loader class="mx-auto" type="list-item" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-skeleton-loader class="mx-auto" type="image" height="220" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <v-row>
        <v-col cols="6">
          <v-text-field
            dense
            :value="form.description.toUpperCase()"
            :error-messages="descriptionErrors"
            :counter="30"
            label="Descrição do Agendamento"
            outlined
            @input="
              $v.form.description.$touch()
              form.description = $event.toUpperCase().trim()
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
        <v-col cols="6">
          <v-datetime-picker
            label="Data"
            v-model="datetime"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>
            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>
      </v-row>
      <DraggAndDrop
        dragname="Ações"
        :valoresDisponiveisComboBox="acoesDisponiveis"
        @dragUpdate="updateAcoes($event)"
        :opcoesSelecionadas="acoesSelecionadas"
        class="mr-4"
      />
      <v-divider dark vertical />
      <v-divider dark />
      <v-divider dark vertical />
      <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
    </v-form>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'

import agendamentosStore from '../_store'
import acoes from '../_components/acoes'
import AgendamentosHttpService from '../_services/AgendamentosHttpService'
import { validateComputed, validateData } from '../_validates/validateData'

import DraggAndDrop from './DraggAndDrop'

export default {
  name: 'AbaAgendamentoData',
  mixins: [validationMixin],
  props: {
    _id: String,
  },
  components: { Snackbar, DraggAndDrop, FixedButtons },
  data: () => ({
    form: {
      active: true,
      description: '',
      tipo: 'data',
      dataHora: '',
      acao: [],
    },
    datetime: new Date(),
    dateProps: {
      locale: 'pt-br',
      color: 'bluePcm',
    },
    timeProps: {
      color: 'bluePcm',
      scrollable: true,
      format: '24hr',
    },
    textProps: {
      outlined: true,
      dense: true,
    },
    acoesSelecionadas: [],
    acoesDisponiveis: [...acoes],
    text: '',
    snackbar: false,
    showSkeleton: true,
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('abaAgendamentoDataModulePABXStore', ['getagendamentoSelecionado']),
  },

  async created() {
    registerVuexModule(this.$store, 'abaAgendamentoDataModulePABXStore', agendamentosStore)

    if (this._id) {
      this.form = this.getagendamentoSelecionado
      this.datetime = new Date(this.getagendamentoSelecionado.dataHora)

      this.acoesSelecionadas = Object.values(this.getagendamentoSelecionado.acao)
    }
    this.showSkeleton = false
  },

  methods: {
    cancelEvent(parent) {
      parent.resetPicker()
      this.$emit('input', null)
    },

    updateAcoes(event) {
      this.form.acao = event
    },

    async salvar() {
      let count = 0
      this.pararLoader.parar = false

      if (this.form.acao.length > 0) {
        this.form.acao.forEach(reg => {
          if (reg.regex_id || reg.agente_id != '' || reg.backup_total != '' || reg.deparment_id != '') {
            count++
          }
        })
        if (count <= 0) {
          this.text = 'Favor inserir os valores dentro da ação selecionada.'
          this.pararLoader.parar = true
          this.snackbar = true
          return
        }
      }

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        this.pararLoader.parar = true
        return
      }
      try {
        this.form.dataHora = moment(this.datetime).format('YYYY-MM-DD HH:mm:ss')
        if (this._id) {
          await AgendamentosHttpService.puttarefa(this.form)
        } else {
          await AgendamentosHttpService.posttarefa(this.form)
        }

        this.$router.push({ name: 'agendamento' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'agendamento' })
    },
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
